export default __webpack_public_path__ + "static/media/circle-hold@3x.e2d26db5.png";